import React from "react";
import { ComingSoonPage } from "@/pages/ComingSoonPage";
import { LayoutDashboard } from "lucide-react";

export default function DashboardPage() {
  return (
    <ComingSoonPage
      title="Dashboard"
      description="Your business overview, key metrics, and quick actions — all in one place."
      icon={LayoutDashboard}
      accent="#00A3E0"
    />
  );
}
